import actions from "./actions";
import { mutations, state } from "./mutations";

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
